import { Component, OnInit, ViewChild, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ProductDialogComponent } from '../../shared/products-carousel/product-dialog/product-dialog.component';
import { AppService } from '../../app.service';
import { SearchProduct, Product, Category } from "../../app.models";
import { Settings, AppSettings } from 'src/app/app.settings';
import { isPlatformBrowser } from '@angular/common';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { GlobalSearchService } from 'src/app/_services/GlobalSearch.Service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  @ViewChild('sidenav', { static: true }) sidenav: any;
  public sidenavOpen: boolean = true;
  private sub: any;
  public viewType: string = 'grid';
  public viewCol: number = 25;
  public counts = [12, 24, 36];
  public count: any;
  public sortings = ['Sort by Default', 'Best match', 'Lowest first', 'Highest first'];
  public sort: any;
  public products: Array<Product> = [];
  public productList: any = [];
  public categories: any = [];
  // public brands = [];
  public priceFrom: number = 0;
  public priceTo: number = 0;
  public page: any;
  public settings: Settings;
  public selectedCategory: string;
  public searchProduct: string;
  public productSearch: SearchProduct;
  constructor(public appSettings: AppSettings,
    private activatedRoute: ActivatedRoute,
    public appService: AppService,
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthenticationService,
    public globalSearchService: GlobalSearchService,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.getAllProducts();

    this.globalSearchService.filteredCategory.subscribe((value: string) => {
      // this is where you would apply your existing filtering.
      this.selectedCategory = value;
    });
    this.globalSearchService.filteredProduct.subscribe((value: string) => {
      this.searchProduct = value;
    });

    this.count = this.counts[0];
    this.sort = this.sortings[0];
    this.sub = this.activatedRoute.params.subscribe(params => {
      //console.log(params['name']);
    });
    if (window.innerWidth < 960) {
      this.sidenavOpen = false;
    };
    if (window.innerWidth < 1280) {
      this.viewCol = 33.3;
    };
    this.getCategories();
    //this.getAllProducts();
    this.productSearch = {
      "categoryName": this.selectedCategory,
      "productName": this.searchProduct,
      "minValue": this.priceFrom,
      "maxValue": this.priceTo
    };

    //this.getProductsByFilter(this.productSearch);

    this.globalSearchService.filteredProduct.next("");
    this.globalSearchService.filteredCategory.next("");

  }



  public getProductsByFilter = (productSearch) => {

    this.appService.getProductsByFilter("api/Product/GetFilterProducts", productSearch).subscribe(data => {
      //this.appService.getProducts("featured").subscribe(data => {

      this.products = data;
      // for (var index = 0; index < 3; index++) {
      //   this.products = this.products.concat(this.products);
      // }
    },
      error => {
        console.log(error.error.errors);
      })
  }

  public getAllProducts = () => {

    // let token = JSON.parse(window.sessionStorage.getItem('userId')).tokenInfo.token;
    // alert(token);

    //this.appService.getProducts("api/Product/").subscribe(data => {
    debugger;
   this.appService.getProducts("/api/Product/GetProductByUserStateId/" ).subscribe(data => {
      this.products = data;
      console.log("products",this.products);

    },
      error => {
        console.log(error.error.errors);
      })
  }


  public getCategories() {
    if (this.appService.Data.categories.length == 0) {
      this.appService.getCategories("api/ProductCategory").subscribe(data => {
        this.appService.Data.categories = data;
        this.categories = this.appService.Data.categories;

      });
    }
    else {
      this.categories = this.appService.Data.categories;
    }
  }

  // public getBrands() {
  //   this.brands = this.appService.getBrands();
  //   this.brands.forEach(brand => { brand.selected = false });
  // }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    (window.innerWidth < 960) ? this.sidenavOpen = false : this.sidenavOpen = true;
    (window.innerWidth < 1280) ? this.viewCol = 33.3 : this.viewCol = 25;
  }

  public changeCount(count) {
    this.count = count;
    // this.getAllProducts();
    this.productSearch = {
      "categoryName": this.selectedCategory,
      "productName": this.searchProduct,
      "minValue": this.priceFrom,
      "maxValue": this.priceTo
    };
    this.getProductsByFilter(this.productSearch);
  }

  public changeSorting(sort) {
    this.sort = sort;
  }

  public changeViewType(viewType, viewCol) {
    this.viewType = viewType;
    this.viewCol = viewCol;
  }

  public openProductDialog(product) {
    let dialogRef = this.dialog.open(ProductDialogComponent, {
      data: product,
      panelClass: 'product-dialog',
      direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });
    dialogRef.afterClosed().subscribe(product => {
      if (product) {
        this.router.navigate(['/products', product.id, product.name]);
      }
    });
  }

  public onPageChanged(event) {
    this.page = event;
    //this.getAllProducts();
    this.productSearch = {
      "categoryName": this.selectedCategory,
      "productName": this.searchProduct,
      "minValue": this.priceFrom,
      "maxValue": this.priceTo
    };
    this.getProductsByFilter(this.productSearch);
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }

  public onChangePrice() {

    this.productSearch = {
      "categoryName": this.selectedCategory,
      "productName": "",
      "minValue": this.priceFrom,
      "maxValue": this.priceTo
    };
    this.getProductsByFilter(this.productSearch);

  }

  public onChangeCategory(event) {
    if (event.target) {
      // this.router.navigate(['/products', event.target.innerText.toLowerCase()]);
      this.selectedCategory = event.target.innerText.toLowerCase();
      this.productSearch = {
        "categoryName": this.selectedCategory,
        "productName": "",
        "minValue": this.priceFrom,
        "maxValue": this.priceTo
      };
      this.getProductsByFilter(this.productSearch);

    }
  }

}
